import { differenceInMilliseconds, isBefore } from "date-fns";

const SHIFT_ENDS_SOON_THRESHOLD = 0.5;

export function getIsShiftEndingSoon(params: {
  shiftStartDate: Date;
  shiftEndDate: Date;
  now: Date;
}): boolean {
  const { shiftStartDate, shiftEndDate, now } = params;
  const totalDuration = differenceInMilliseconds(shiftEndDate, shiftStartDate);

  if (totalDuration <= 0) {
    return false;
  }

  if (isBefore(now, shiftStartDate)) {
    return false;
  }

  const elapsed = differenceInMilliseconds(now, shiftStartDate);
  return elapsed / totalDuration >= SHIFT_ENDS_SOON_THRESHOLD;
}
